import React, { Fragment, useEffect, useState, useRef } from 'react';
import { Box, ClickAwayListener, Grow, List, ListItem, Paper, Popper, Tab, Tabs } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { AlignSettingIcon } from '../../../../config/svg/CommonSvg';
import LinearLoader from '../../../Common/Loader';
import { CreateOKRIcon } from '../../../../config/svg/MyGoalSvg';
import { CycleDropdown } from '../../../Common/CycleDropdown';
import { useDispatch, useSelector } from 'react-redux';
import { setDefaultOkrName } from '../../../../action/common';
import { getLocalStorageItem } from '../../../../services/StorageService';
import { checkUnSavePopUpVisible, getCycleDefaultSelection, getUserDetails } from '../../../../config/utils';
import * as Moment from 'moment';
import { extendMoment } from 'moment-range';
import { Enums } from '../../../../config/enums';
import {
	alignSelectedCycle,
	getDefaultOkrCycleDetails,
	getDefaultOkrDesignation,
	getDefaultOkrDetailsForEditCall,
	getDefaultOkrPerformanceRole,
	pastCycleSelected,
} from '../../../../action/adminDefaultOkr';
import { getOkrMasterData } from '../../../../action/myGoal';
import AlertDialog from '../../../Common/Dialog';
import { CreateDefaultKpi } from './CreateDefaultKpi';
import { getCyclesData } from '../../../../action/organization';

export const CreateKpi: React.FC<any> = (props: any) => {
	const { parentOrganisation, setIsCreateOpen, getEmployeeId } = props;
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const { enqueueSnackbar } = useSnackbar();
	const { cycleDetailsForDefaultKpi } = useSelector((state: any) => state.kpiReducer);
	const { designationDetailsForDefaultOkr, performanceRoleDetailsForDefaultOkr, openCopyOkr } = useSelector(
		(state: any) => state.adminDefaultOkrReducer
	);
	const userDetail: any = getUserDetails();

	const { cycleMasterData } = useSelector((state: any) => state.organizationReducer);
	const { okrMasterData } = useSelector((state: any) => state.okrReducer);
	const { kpiType } = useSelector((state: any) => state.kpiReducer);
	const moment = extendMoment(Moment);
	const cycleId = getLocalStorageItem('cycleId2') ? parseInt(getLocalStorageItem('cycleId2') || '0') : 0;
	const currentCycleYear = getLocalStorageItem('year') || null;
	const defaultGoalKeyObject = {
		goalKeyId: Enums.ZERO,
		isEditable: true,
		keyDescription: '',
		score: 0,
		startDate: null,
		endDate: null,
		importedType: 0,
		importedId: 0,
		progress: 0,
		source: 0,
		metricId: 0,
		currencyId: Enums.ZERO,
		currentValue: 0,
		assignmentTypeId: 0,
		krStatusId: 0,
		currencyCode: '',
		goalStatusId: 0,
		startValue: Enums.ZERO,
		targetValue: Enums.ZERO,
		owner: 0,
		isMetricChanged: true,
		confidenceId: 0,
		weightId: 0,
		kpiType: getEmployeeId() === userDetail.employeeId ? 3 : 2,
		isGroupTarget: false,
		isGroupTargetOn: false,
		contributorValue: 0,
	};

	const defaultOkrDetailsObj = {
		goalObjectiveId: Enums.ZERO,
		employeeId: getEmployeeId(),
		year: 0,
		kpiType: getEmployeeId() === userDetail.employeeId ? 3 : 2,
		objectiveName: '',
		isEditable: true,
		objectiveDescription: '',
		objectiveCycleId: Enums.ZERO,
		importedType: 0,
		importedId: 0,
		name: '',
		startDate: null,
		endDate: null,
		source: 0,
		sequence: 0,
		goalStatusId: 1,
		goalTypeId: 2,
		score: 0,
		owner: getEmployeeId(),
		kpiCategoryMasterId: 0,
		myGoalsDetails: [],

		goalNatureId: 0,
		isCoach: false,
	};
	const refObject = useRef<any>(null);

	const [selectedTab, setTabSelected] = useState(false);
	const [showLoader, setShowLoader] = useState(false);
	const [listLoading, setListLoading] = useState(false);
	const [selectedCycle, setSelectedCycle] = useState({});
	const [cycleList, setCycleList] = useState([]);
	const [organisationDetails, setOrganisationDetails] = useState<any>({});
	const [orgOriginalData, setOrgOriginalData] = useState<any>({});
	const [selectedDate, setDate] = useState(moment('2020-12-12'));
	const [selectedKpiDate, setSelectedKpiDate] = useState(moment('2020-12-12'));
	const [zeroNotAllowed, setZeroNotAllowed] = useState<boolean>(false);
	const [formEdited, setFormEdited] = useState<boolean>(false);
	const [emailPlanningPeriodError, setEmailPlanningPeriodError] = useState<any>({
		error: '',
		helperText: '',
		type: '',
	});
	const [emailExecutionPeriodError, setEmailExecutionPeriodError] = useState<any>({
		error: '',
		helperText: '',
		type: '',
	});
	const [cycleCompletionPeriodError, setCycleCompletionPeriodError] = useState<any>({
		error: '',
		helperText: '',
		type: '',
	});
	const [defaultOkrTagNameError, setDefaultOkrTagNameError] = useState<any>({
		error: false,
		helperText: '',
		type: '',
	});
	const [selectedCycleDetails, setSelectedCycleDetails] = useState<any>(null);
	const [isCurrentCycle, setIsCurrentCycle] = useState<any>(null);
	// const [currentSelectedCycleYear, setCurrentSelectedCycleYear] = useState(currentCycleYear);
	const [currentCycleId, setCurrentCycleId] = useState(cycleId);
	const [selectedDateRange, setSelectedDateRange] = useState<any>(null);
	const [currentSelectedCycleYear, setCurrentSelectedCycleYear] = useState(currentCycleYear);
	// ==========================================================================================
	const [defaultOkrFormDetails, setDefaultOkrFormDetails] = useState({
		...defaultOkrDetailsObj,
		myGoalsDetails: [{ ...defaultGoalKeyObject }],
	});
	const [defaultOkrDesignationDetails, setDefaultOkrDesignationDetails] = useState([]);
	const [defaultOkPerformanceRoleDetails, setDefaultOkrPerformanceDetails] = useState([]);
	const [editDetails, setEditDetails] = useState<any>(null);
	const [isDefaultOkrFormEdited, setIsDefaultOkrFormEdited] = useState<boolean>(false);
	const [isDefaultOkrFormEditedData, setIsDefaultOkrFormEditedData] = useState<any>(null);
	const [modalPerformanceProps, setModalPerformanceProps] = useState<any>({ open: false, message: '', details: '' });
	const [highlightDefaultOkr, setHighlightDefaultOkr] = useState<any>(0);
	const [openDefaultObjDrawer, setOpenDefaultObjDrawer] = useState<boolean>(false);
	const [openDefaultKrDrawer, setOpenDefaultKrDrawer] = useState<any>({ open: false, details: null });
	const [weightSelectionOpen, setWeightSelectionOpen] = useState<boolean>(false);

	// const [openDefaultObjDrawer, setOpenDefaultObjDrawer] = useState<boolean>(false);
	// const [selectedAssignTab, setSelectedAssignTab] = useState<any>(0);
	useEffect(() => {
		dispatch(pastCycleSelected(false));
	}, []);
	useEffect(() => {
		dispatch(alignSelectedCycle(selectedCycleDetails));
	}, [selectedCycleDetails]);
	useEffect(() => {
		if (
			cycleDetailsForDefaultKpi &&
			cycleDetailsForDefaultKpi.cycleDetails &&
			cycleDetailsForDefaultKpi.cycleDetails.length
		) {
			let currentQuarterDetails: any = getCycleDefaultSelection(cycleDetailsForDefaultKpi.cycleDetails, cycleId);
			if (currentQuarterDetails) {
				setSelectedCycleDetails({ ...currentQuarterDetails });
				setIsCurrentCycle({ ...currentQuarterDetails });
				// setCurrentSelectedCycleYear(currentQuarterDetails?.year || currentCycleYear);
				setCurrentCycleId(currentQuarterDetails?.organisationCycleId || currentCycleId);
				const { startDate, endDate } = currentQuarterDetails;
				setSelectedDateRange(moment().range(new Date(startDate), new Date(endDate)));
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [cycleDetailsForDefaultKpi]);

	useEffect(() => {
		setShowLoader(true);

		if (!cycleMasterData.length) {
			getCyclesData();
		}
		dispatch(getDefaultOkrPerformanceRole());
		if (!Boolean(okrMasterData)) {
			dispatch(getOkrMasterData());
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (designationDetailsForDefaultOkr && performanceRoleDetailsForDefaultOkr) {
			setDefaultOkrDesignationDetails(designationDetailsForDefaultOkr);
			setDefaultOkrPerformanceDetails(performanceRoleDetailsForDefaultOkr);
			setShowLoader(false);
		}
	}, [designationDetailsForDefaultOkr, performanceRoleDetailsForDefaultOkr]);

	useEffect(() => {
		if (parentOrganisation && parentOrganisation.teamId) {
			setOrganisationDetails(parentOrganisation);
			setOrgOriginalData(parentOrganisation);
			setDate(parentOrganisation.cycleStartDate);
			setSelectedKpiDate(parentOrganisation.kpiCycleStartDate);
			if (parentOrganisation?.defaultOkrTagName || '') {
				dispatch(setDefaultOkrName(parentOrganisation?.defaultOkrTagName || ''));
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [parentOrganisation]);

	useEffect(() => {
		if (cycleMasterData?.length && parentOrganisation?.teamId) {
			// setShowLoader(false);
			let cycles = cycleMasterData.map((cycle: any) => {
				return {
					...cycle,
					label: cycle.cycleName,
					value: cycle.cycleId,
				};
			});
			let currentCycle = cycles.filter((item: any) => item.cycleId === parentOrganisation.cycleId);
			setCycleList(cycles);
			setSelectedCycle(currentCycle[0]);
		}
	}, [cycleMasterData, parentOrganisation]);

	/** OUT SIDE CLICK */
	useEffect(() => {
		document.addEventListener('click', handleClickOutside, true);
		return () => {
			document.removeEventListener('click', handleClickOutside, true);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isDefaultOkrFormEdited]);

	const handleClickOutside = (event: any) => {
		if (
			refObject.current &&
			!refObject.current?.contains(event.target) &&
			(checkUnSavePopUpVisible(event) || event.target.id === 'back-btn') &&
			isDefaultOkrFormEdited
		) {
			const calendarBox = document.getElementsByClassName('calender-control-inner');
			const weightageBox = document.getElementsByClassName('weightage-dropdown');
			const krAttributeBox = document.getElementsByClassName('default-kr-attribute-panel');
			if (
				openDefaultObjDrawer ||
				openDefaultKrDrawer?.open ||
				weightSelectionOpen ||
				(calendarBox && calendarBox.length > 0 && calendarBox[0].contains(event.target)) ||
				(weightageBox && weightageBox.length > 0 && weightageBox[0].contains(event.target)) ||
				(krAttributeBox && krAttributeBox.length > 0 && krAttributeBox[0].contains(event.target))
			) {
				//
			} else {
				const dialogDiv = document.getElementsByClassName('MuiDialog-paper');
				if (dialogDiv.length === 0 || !dialogDiv[0].contains(event.target)) {
					event.preventDefault();
					event.stopPropagation();

					// console.log('isDefaultOkrFormEdited === OPEN Model ===> ', isDefaultOkrFormEdited);
					setModalPerformanceProps({ open: true, message: t('unSavedItemAlert'), details: '', event: event });
				}
			}
		}
	};
	const handlePerformanceCloseModal = async (e: any, type: any) => {
		e.preventDefault();
		if (type === 1) {
			if (modalPerformanceProps?.event) {
				// setTabSelected(1);
				// setDefaultOkrFormDetails(defaultOkrDetailsObj);
				// setEditDetails(null);
				/** OUT SIDE CLICK */
				await setIsDefaultOkrFormEdited(false);
				const { target } = modalPerformanceProps?.event || {};
				const clonedNativeEvent = document.createEvent('HTMLEvents');
				clonedNativeEvent.initEvent('click', true, false);
				target.dispatchEvent(clonedNativeEvent);
			} else {
				// setPerformanceReviewFormType('Add');
				// setEditableDetails(null);
				// setSelectedTemplateDetails([]);
				// setSelectedCoreValueTemplateDetails([]);
			}

			setModalPerformanceProps({ open: false, message: '', details: '' });
		} else {
			setModalPerformanceProps({ open: false, message: '', details: '' });
		}
	};

	const showApiMsgs = (msg: string, variant: any) => {
		enqueueSnackbar(msg, {
			variant: variant,
			autoHideDuration: 5000,
		});
	};

	const handleAlignSettingsSave = async () => {
		if (organisationDetails?.emailExecutionPeriod === 0 && organisationDetails?.isEmailExecutionPeriod) {
			setZeroNotAllowed(true);
			setEmailExecutionPeriodError({
				error: t('zeroNotAllowedText'),
				helperText: t('zeroNotAllowedText'),
				type: 'emailExecutionPeriod',
			});

			return false;
		}
		if (
			!organisationDetails?.defaultOkrTagName ||
			(organisationDetails?.defaultOkrTagName && organisationDetails?.defaultOkrTagName?.trim() === '')
		) {
			setDefaultOkrTagNameError({
				error: true,
				helperText: 'Please enter default okr name',
				type: 'defaultOkrTagName',
			});
			return false;
		}
		if (
			(!organisationDetails?.cycleCompletionPeriod || organisationDetails?.cycleCompletionPeriod?.trim() === '') &&
			organisationDetails?.isCycleCompletion
		) {
			setZeroNotAllowed(true);
			setCycleCompletionPeriodError({
				error: t('zeroNotAllowedText'),
				helperText: t('zeroNotAllowedText'),
				type: 'cycleCompletionPeriod',
			});

			return false;
		}
		setShowLoader(true);
		let orgData = {
			teamId: organisationDetails.teamId,
			cycleId: organisationDetails.cycleId,
			gracePeriod: organisationDetails.gracePeriod,
			planningPeriod: organisationDetails.planningPeriod,
			kpiPlanningPeriod: organisationDetails.kpiPlanningPeriod,
			isWeightageAvailable: organisationDetails.isWeightageAvailable,
			isConfidenceAvailable: organisationDetails.isConfidenceAvailable,
			isTaskAvailable: organisationDetails.isTaskAvailable,
			isNotesAvailable: organisationDetails.isNotesAvailable,
			cycleStartDate: organisationDetails.cycleStartDate,
			emailPlanningPeriod: organisationDetails.emailPlanningPeriod,
			emailExecutionPeriod: organisationDetails.emailExecutionPeriod,
			isEmailPlanningPeriod: organisationDetails.isEmailPlanningPeriod,
			isEmailExecutionPeriod: organisationDetails.isEmailExecutionPeriod,
			industryType: organisationDetails.industryType,
			defaultOkrTagName: organisationDetails?.defaultOkrTagName
				? organisationDetails?.defaultOkrTagName?.trim()
				: 'Default',
			isCycleCompletion: organisationDetails.isCycleCompletion,
			cycleCompletionPeriod: organisationDetails?.cycleCompletionPeriod
				? organisationDetails.cycleCompletionPeriod
						.split(',')
						.filter((item: any) => item)
						.join(',')
				: organisationDetails.cycleCompletionPeriod,
			isAllConsecutiveDay: organisationDetails?.isAllConsecutiveDay || false,
		};
		const response: any = await props.updateAlignSettings(orgData);
		if (response && response?.data?.status === 200) {
			setShowLoader(false);
			showApiMsgs(t('alignSettingsUpdatedSuccess'), 'success');
			setDefaultOkrTagNameError({
				error: '',
				helperText: '',
				type: '',
			});
		} else {
			const responseAPI = response?.data?.messageList || {};
			const keys = Object.keys(responseAPI);
			const messages = keys && keys?.length ? keys?.map((item) => responseAPI[item]) : t('someErrorOccurred');
			showApiMsgs(`${messages}`, 'error');
			setShowLoader(false);
		}
	};

	const handleAlignSettingReset = async () => {
		setOrganisationDetails(orgOriginalData);
	};

	const onCycleSelect = (value: any) => {
		setSelectedCycle(value);
	};

	const handleOrganisationIndustryChange = (e: any) => {
		const { name, value } = e.target;
		let organisation = { ...organisationDetails };
		organisation[name] = value;
		setOrganisationDetails(organisation);
		setFormEdited(true);
	};

	//
	const handleOrganisationFieldsChange = (e: any) => {
		const { name, value } = e.target;
		if (e.target.value !== 0) {
			setZeroNotAllowed(false);
		}
		let organisation = { ...organisationDetails };
		organisation[name] = name === 'cycleCompletionPeriod' ? value : parseInt(value);
		setOrganisationDetails(organisation);
		setFormEdited(true);
	};
	const handleDefaultOkrTagNameChange = (e: any) => {
		const { name, value } = e.target;
		let organisation = { ...organisationDetails };
		organisation[name] = value;
		setOrganisationDetails(organisation);
		setFormEdited(true);
		setDefaultOkrTagNameError({
			error: '',
			helperText: '',
			type: '',
		});
	};

	const handleOrganisationFieldsBlur = (e: any) => {
		const { name, value } = e.target;
		let organisation = { ...organisationDetails };
		if (!value) {
			organisation[name] = 0;
		}
		setOrganisationDetails(organisation);
		setFormEdited(true);
	};

	const handleOrganisationToggleChange = (e: any) => {
		const { name, checked } = e.target;
		let organisation = { ...organisationDetails };
		organisation[name] = checked;

		if (name === 'isEmailPlanningPeriod' && !checked) {
			organisation['emailPlanningPeriod'] = 0;
		}

		if (name === 'isEmailExecutionPeriod' && !checked) {
			organisation['emailExecutionPeriod'] = 0;
		}
		if (name === 'isCycleCompletion') {
			organisation['cycleCompletionPeriod'] = checked ? '7,3' : '';
			organisation['isAllConsecutiveDay'] = false;
		}

		setOrganisationDetails(organisation);
		setFormEdited(true);
	};
	const handleEditDefaultOkrClick = (event: any, okrDetails: any) => {
		try {
			getEditDetailsForOkr(okrDetails);
		} catch (error) {
			console.error(error);
		}
	};
	const getEditDetailsForOkr = async (okrDetails: any) => {
		try {
			if (okrDetails && okrDetails?.goalObjectiveId) {
				setShowLoader(true);
				const response: any = await dispatch(getDefaultOkrDetailsForEditCall(okrDetails?.goalObjectiveId));
				if (response && response?.data && response?.data?.status === Enums.STATUS_SUCCESS) {
					const { entity } = response?.data || {};
					const updatedDetails = { ...entity };
					updatedDetails.assignIds =
						updatedDetails?.assignIds && updatedDetails?.assignIds?.length
							? updatedDetails?.assignIds.map((role: any) => {
									if (role?.name) {
										role.label = role.name;
									}
									if (role?.emailId) {
										role.value = role.emailId;
									} else {
										role.value = role.userCount;
									}
									if (role?.image) {
										role.imagePath = role.image;
									}
									return role;
							  })
							: [];
					const newRow = {
						...defaultGoalKeyObject,
						startDate: updatedDetails?.startDate || selectedCycleDetails?.startDate,
						endDate: updatedDetails?.endDate || selectedCycleDetails?.endDate,
						dueDate: updatedDetails?.endDate || selectedCycleDetails?.endDate,
						defaultGoalKeyAssignMappings:
							updatedDetails?.assignType === Enums.FOUR
								? updatedDetails?.assignIds
								: updatedDetails?.assignIds && updatedDetails?.assignIds?.length
								? updatedDetails?.assignIds?.map((item: any) => {
										return {
											...item,
											defaultGoalKeyAssignMappingId: Enums.ZERO,
											goalKeyId: defaultOkrFormDetails?.goalObjectiveId || Enums.ZERO,
											weight: Enums.ONE,
											startValue: Enums.ZERO,
											targetValue: Enums.ZERO,
										};
								  })
								: [],
					};
					updatedDetails.myGoalsDetails =
						updatedDetails?.myGoalsDetails && updatedDetails?.myGoalsDetails?.length
							? updatedDetails?.myGoalsDetails?.map((kr: any) => {
									kr.defaultGoalKeyAssignMappings =
										kr?.defaultGoalKeyAssignMappings && kr?.defaultGoalKeyAssignMappings?.length
											? kr?.defaultGoalKeyAssignMappings?.map((role: any) => {
													let extraParam = {};
													// if (role?.assignId) {
													const recordData =
														updatedDetails?.assignIds && updatedDetails?.assignIds?.length
															? updatedDetails?.assignIds?.find((item: any) => item?.assignId === role?.assignId)
															: null;
													extraParam = {
														...extraParam,
														name:
															updatedDetails?.assignType === Enums.FOUR
																? 'All Employees in the organization'
																: recordData?.name || '',
														userCount:
															updatedDetails?.assignType === Enums.FOUR
																? okrMasterData?.totalUserCount
																: recordData?.userCount || Enums.ZERO,
														value: recordData?.value || '',
													};
													if (updatedDetails?.assignType === Enums.THREE) {
														extraParam = {
															...extraParam,
															label: recordData?.label || '',
															emailId: recordData?.emailId || recordData?.value || '',
															imagePath: recordData?.imagePath || null,
															isActive: recordData?.isActive || false,
														};
													}
													// }
													return { ...role, ...extraParam };
											  })
											: [];
									return kr;
							  })
							: [];

					setEditDetails(entity);
					setDefaultOkrFormDetails({ ...updatedDetails });
				} else {
					const { messageList } = response?.data || {};
					const keys = messageList ? Object.keys(messageList) : null;
					const messages = keys && keys?.length ? keys.map((item) => messageList[item]) : [];
					showApiMsg('error', messages || 'Error occurred while fetching default okr details');
				}
				setShowLoader(false);
			} else {
				showApiMsg('error', 'Error occurred while fetching default okr details');
			}
		} catch (error) {
			console.error(error);
			showApiMsg('error', 'Error occurred while fetching default okr details');
			setShowLoader(false);
		}
	};
	const showApiMsg = (variant: any, msg: any) => {
		enqueueSnackbar(msg || 'Error occurred while fetching default okr details', {
			variant: variant || 'error',
			autoHideDuration: 3000,
		});
	};
	return (
		<>
			<CreateDefaultKpi
				{...props}
				refObject={refObject}
				defaultOkrDetailsObj={defaultOkrDetailsObj}
				setDefaultOkrOpen={() => {}}
				setTabSelected={setTabSelected}
				allCycleDetails={cycleDetailsForDefaultKpi}
				cycleId={cycleId}
				defaultGoalKeyObject={defaultGoalKeyObject}
				defaultOkrFormDetails={defaultOkrFormDetails}
				setDefaultOkrFormDetails={setDefaultOkrFormDetails}
				defaultOkrDesignationDetails={defaultOkrDesignationDetails}
				defaultOkPerformanceRoleDetails={defaultOkPerformanceRoleDetails}
				selectedCycleDetailsInTab={selectedCycleDetails}
				mode={editDetails ? 'Edit' : 'Add'}
				showLoader={showLoader}
				setShowLoader={setShowLoader}
				editDetails={editDetails}
				setEditDetails={setEditDetails}
				setSelectedCycle={setSelectedCycle}
				setSelectedOkrListCycleDetails={setSelectedCycleDetails}
				showApiMsg={showApiMsg}
				isDefaultOkrFormEdited={isDefaultOkrFormEdited}
				isDefaultOkrFormEditedData={isDefaultOkrFormEditedData}
				setIsDefaultOkrFormEditedData={setIsDefaultOkrFormEditedData}
				setIsDefaultOkrFormEdited={setIsDefaultOkrFormEdited}
				setHighlightDefaultOkr={setHighlightDefaultOkr}
				openDefaultObjDrawer={openDefaultObjDrawer}
				setOpenDefaultObjDrawer={setOpenDefaultObjDrawer}
				openDefaultKrDrawer={openDefaultKrDrawer}
				setOpenDefaultKrDrawer={setOpenDefaultKrDrawer}
				weightSelectionOpen={weightSelectionOpen}
				setWeightSelectionOpen={setWeightSelectionOpen}
			/>
			{modalPerformanceProps && modalPerformanceProps.open && (
				<AlertDialog
					module='PerformanceReviewList'
					isCancel={false}
					message={modalPerformanceProps?.message || ''}
					handleCloseModal={handlePerformanceCloseModal}
					modalOpen={modalPerformanceProps.open}
				/>
			)}
		</>
	);
};
